import { render, staticRenderFns } from "./AssessmentTab.vue?vue&type=template&id=144c8b40"
import script from "./AssessmentTab.vue?vue&type=script&lang=js"
export * from "./AssessmentTab.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTab.vue?vue&type=style&index=0&id=144c8b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports